import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import { Spacing } from './spacing';
/**
 * We don't want breakpoints to change based on the user's default font
 * size, so for Breakpoints we specifically stringify them as pixels.
 */

export var Breakpoint = /*#__PURE__*/function (_Spacing) {
  _inherits(Breakpoint, _Spacing);

  var _super = _createSuper(Breakpoint);

  function Breakpoint() {
    _classCallCheck(this, Breakpoint);

    return _super.apply(this, arguments);
  }

  _createClass(Breakpoint, null, [{
    key: "fromPixels",
    value: function fromPixels(px) {
      return new Breakpoint("".concat(px, "px"));
    }
  }]);

  return Breakpoint;
}(Spacing);
export var breakpoints = {
  xs: Breakpoint.fromPixels(480),
  sm: Breakpoint.fromPixels(576),
  md: Breakpoint.fromPixels(768),
  lg: Breakpoint.fromPixels(992),
  xl: Breakpoint.fromPixels(1200),
  xl2: Breakpoint.fromPixels(1600)
};
/* Usage:
    @media ${({ theme }) => above(theme.breakpoints.lg)} {
      // styles for (min-width: 993px)
    }
*/

export function above(breakpoint) {
  return "(min-width: ".concat(breakpoint.getValue() + 1, "px)");
}
/* Usage:
    @media ${({ theme }) => belowOrEqualTo(theme.breakpoints.lg)} {
      // styles for (max-width: 992px)
    }
*/

export function belowOrEqualTo(breakpoint) {
  return "(max-width: ".concat(breakpoint.getValue(), "px)");
}